import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { IconName, ButtonVariant, PopoverPosition, ButtonType, ButtonSize, DropdownSelectionType, DropdownOptionGroup, BadgeOption, BadgeType, DropdownOptionDefault, DropdownOptionType } from '@yupma/ui-kit';
import { PhoneLabel, PhoneValue } from 'server-model';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrl: './phone-input.component.scss'
})
export class PhoneInputComponent {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: PhoneValue[] = [];
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Input() showLabel: boolean = true;
  @Output() valueChange = new EventEmitter<PhoneValue[]>();

  iconNames = IconName;
  buttonVariants = ButtonVariant;
  popoverPositions = PopoverPosition;
  buttonTypes = ButtonType;
  isEditDropdownOpen: boolean = false;
  isPhoneDropdownOpen: boolean = false;
  buttonSizes = ButtonSize;
  dropdownSelectionTypes = DropdownSelectionType;
  phoneDropdownOptions: DropdownOptionGroup[] = [];


  // ngOnChanges(changes: SimpleChanges) {
  //   if (!!(changes['value'])) {
  //     this.createPhoneDropdown()
  //   }
  // }


  // ngOnInit() {
  //   this.createPhoneDropdown()
  // }

  // private createPhoneDropdown() {
  //   if (this.value && this.value.length) {
  //     this.phoneDropdownOptions = [];
  //     let primaryBadge: BadgeOption = { label: 'Primary', type: BadgeType.TIP };
  //     let phoneDropdownGroup = new DropdownOptionGroup('', []);
  //     this.value.forEach((item) => {
  //       let option = new DropdownOptionDefault(DropdownOptionType.DEFAULT, item.label, item.value, false, false, '', '', item.value, '', item.primary ? primaryBadge : undefined);
  //       phoneDropdownGroup.options.push(option);
  //     });
  //     this.phoneDropdownOptions.push(phoneDropdownGroup);
  //   }
  // }

  toggleEditDropdown(state: boolean) {
    this.isEditDropdownOpen = state;
  }

  // togglePhoneDropdown(state: boolean) {
  //   if (this.value && this.value.length) {
  //     this.isPhoneDropdownOpen = state;
  //   } else {
  //     this.isEditDropdownOpen = state;
  //   }
  // }

  updateValue(phones: PhoneValue[]) {
    this.value = phones;
    this.valueChange.emit(this.value);
    // this.createPhoneDropdown()
  }
}
